export const MessagesPageResourcesEN: IMessagesPageResources = {
  placeholderText: "No chats at the moment.",
  addReview: "Review User",
  messages: "Messages",
  seeUser: "See User",
};

export const MessagesPageResourcesDE: IMessagesPageResources = {
  placeholderText: "Momentan keine Chats.",
  addReview: "Benutzer bewerten",
  messages: "Nachrichten",
  seeUser: "Benutzer anzeigen",
};

export interface IMessagesPageResources {
  addReview: string;
  seeUser: string;

  placeholderText: string;
  messages: string;
}
